import {createAction, props} from '@ngrx/store';
import {MitarbeiterDTO} from '../../openapi/beleg-openapi';

export class MitarbeiterDialogActions {
  /** Ohne `mitarbeiter`: Modus „anlegen“. Mit `mitarbeiter`: Modus „umbenennen“. */
  public static open = createAction(
    '[Mitarbeiter-Dialog] Open mitarbeiter-dialog.',
    props<{
      inhaberId: string;
      mitarbeiter?: MitarbeiterDTO;
    }>(),
  );

  public static close = createAction('[Mitarbeiter-Dialog] Close mitarbeiter-dialog.');
}
